import { LenderName } from '@nemuru-eng/js-api-client';

import { LoanPaymentMethodSummaryCard } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/ApplicationSummaryPaymentMethods/components/LoanPaymentMethodSummaryCard';
import { SinglePaymentMethodSummaryCard } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/ApplicationSummaryPaymentMethods/components/SinglePaymentMethodSummaryCard';
import { AbstractPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/AbstractPaymentMethod';
import { AbstractSinglePaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/AbstractSinglePaymentMethod';
import { AutoLoanPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/AutoLoan/entities/PaymentMethod/AutoLoanPaymentMethod';
import { BnplPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/Bnpl/entities/PaymentMethod/BnplPaymentMethod';
import { ConsumerLoanPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/ConsumerLoan/entities/PaymentMethod/ConsumerLoanPaymentMethod';

interface PaymentMethodSummaryFactoryProps {
  paymentMethodEntity: ConsumerLoanPaymentMethod | AbstractSinglePaymentMethod | AbstractPaymentMethod;
  activeLenders?: LenderName[];
  available?: boolean;
}

export const PaymentMethodSummaryFactory = ({
  paymentMethodEntity,
  activeLenders,
  available,
}: PaymentMethodSummaryFactoryProps) => {
  if (
    paymentMethodEntity instanceof AutoLoanPaymentMethod ||
    paymentMethodEntity instanceof BnplPaymentMethod ||
    paymentMethodEntity instanceof ConsumerLoanPaymentMethod
  ) {
    return (
      <LoanPaymentMethodSummaryCard
        paymentMethodEntity={paymentMethodEntity}
        activeLenders={activeLenders}
        available={available}
      />
    );
  }

  if (paymentMethodEntity instanceof AbstractSinglePaymentMethod) {
    return <SinglePaymentMethodSummaryCard paymentMethodEntity={paymentMethodEntity} available={available} />;
  }
  return null;
};
